export const PASSWORD_REQUIREMENT_CLASSNAMES = {
	DEFAULT: "",
	VALID: "valid",
	INVALID: "invalid"
}
